import Vue from "vue";
import Router from "vue-router";
import FrameRoutes from "./common/frame_router";
import FroumRoutes from "./common/froum_router";
import store from "./store";

/* 使用路由依赖 */
Vue.use(Router);

/* 定义路由 */
const router = new Router({
    mode: "history",
    routes: [
        ...FrameRoutes,
        ...FroumRoutes,
        { path: "*", component: () => import("@/routes/exception/404") }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

router.beforeEach((to, from, next) => {
    const user = JSON.parse(localStorage.getItem("IMS_USER"));
    if (user != null) {
        if (Object.keys(store.state.ImsUsers.BaseInfo).length == 0) {
            store.dispatch("ImsUsers/initUserInfo").then(() => {
                next();
            });
        } else {
            next();
        }
    } else {
        if (to.name === "login")
            next();
        else {
            if (window.top === window) {
                window.top.location.href = "/login";
            } else {
                window.top.location.href = "/login?origin=" + location.origin + "&pathname=" + location.pathname;
            }
        }
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js